import { CheckboxStore } from '../../../../../stores/CheckboxStore'
import NewPaginationStore from '../../../../../stores/NewPaginationStore'
import SinglePageSwitcherStore from '../../../../Customers/store/CustomersStore'
import AdminTableFilterStore from '../../../stores/AdminTableFilterStore'
import { AdminTableParamsType } from '../types/admin-table.types'

const allStatusesInitParams: AdminTableParamsType = {}
const pendingStatusesInitParams: AdminTableParamsType = {
  'preset.statuses': [1, 8],
}
const processStatusesInitParams: AdminTableParamsType = {
  'preset.statuses': [2, 4, 5, 11, 20, 24],
}
const refusedStatusesInitParams: AdminTableParamsType = {
  'preset.statuses': [7, 10, 6, 30],
  'preset.ticketStatuses': ['', 1, 5],
}

const completeStatusesInitParams: AdminTableParamsType = {
  'preset.statuses': [6, 3, 16],
  'preset.ticketStatuses': ['', 1, 2, 4],
}

const reportStatusesInitParams: AdminTableParamsType = {
  'preset.statuses': [12, 13, 14, 15, 16],
  'preset.ticketStatuses': ['', 2],
}

export const allStatusesPaginationStore = new NewPaginationStore(
  allStatusesInitParams,
)
export const pendingStatusesPaginationStore = new NewPaginationStore(
  pendingStatusesInitParams,
)
export const processStatusesPaginationStore = new NewPaginationStore(
  processStatusesInitParams,
)
export const refusedStatusesPaginationStore = new NewPaginationStore(
  refusedStatusesInitParams,
)
export const completeStatusesPaginationStore = new NewPaginationStore(
  completeStatusesInitParams,
)
export const reportStatusesPaginationStore = new NewPaginationStore(
  reportStatusesInitParams,
)

export const allStatusesFiltersStore = new AdminTableFilterStore()
export const pendingStatusesFiltersStore = new AdminTableFilterStore()
export const processStatusesFiltersStore = new AdminTableFilterStore()
export const refusedStatusesFiltersStore = new AdminTableFilterStore()
export const completeStatusesFiltersStore = new AdminTableFilterStore()
export const reportStatusesFiltersStore = new AdminTableFilterStore()

export const allStatusesCheckboxStore = new CheckboxStore()
export const pendingStatusesCheckboxStore = new CheckboxStore()
export const processStatusesCheckboxStore = new CheckboxStore()
export const refusedStatusesCheckboxStore = new CheckboxStore()
export const completeStatusesCheckboxStore = new CheckboxStore()
export const reportStatusesCheckboxStore = new CheckboxStore()

export const allStatusesSwitcherStore = new SinglePageSwitcherStore(
  allStatusesPaginationStore,
)
export const pendingStatusesSwitcherStore = new SinglePageSwitcherStore(
  pendingStatusesPaginationStore,
)
export const processStatusesSwitcherStore = new SinglePageSwitcherStore(
  processStatusesPaginationStore,
)
export const refusedStatusesSwitcherStore = new SinglePageSwitcherStore(
  refusedStatusesPaginationStore,
)
export const completeStatusesSwitcherStore = new SinglePageSwitcherStore(
  completeStatusesPaginationStore,
)
export const reportStatusesSwitcherStore = new SinglePageSwitcherStore(
  reportStatusesPaginationStore,
)

export const tabComponents = {
  'все заявки': {
    paginationStore: allStatusesPaginationStore,
    filtersStore: allStatusesFiltersStore,
    checkboxStore: allStatusesCheckboxStore,
    switcherStore: allStatusesSwitcherStore,
  },
  выполненные: {
    paginationStore: completeStatusesPaginationStore,
    filtersStore: completeStatusesFiltersStore,
    checkboxStore: completeStatusesCheckboxStore,
    switcherStore: completeStatusesSwitcherStore,
  },
  'заявки в отчётах': {
    paginationStore: reportStatusesPaginationStore,
    filtersStore: reportStatusesFiltersStore,
    checkboxStore: reportStatusesCheckboxStore,
    switcherStore: reportStatusesSwitcherStore,
  },
  'заявки в работе': {
    paginationStore: processStatusesPaginationStore,
    filtersStore: processStatusesFiltersStore,
    checkboxStore: processStatusesCheckboxStore,
    switcherStore: processStatusesSwitcherStore,
  },
  'не выполненные': {
    paginationStore: refusedStatusesPaginationStore,
    filtersStore: refusedStatusesFiltersStore,
    checkboxStore: refusedStatusesCheckboxStore,
    switcherStore: refusedStatusesSwitcherStore,
  },
  'ожидающие заявки': {
    paginationStore: pendingStatusesPaginationStore,
    filtersStore: pendingStatusesFiltersStore,
    checkboxStore: pendingStatusesCheckboxStore,
    switcherStore: pendingStatusesSwitcherStore,
  },
}

export const resetAllAdminFiltersAndPagination = () => {
  allStatusesPaginationStore.resetParams()
  allStatusesPaginationStore.resetSelectedRow()
  allStatusesCheckboxStore.resetAll(true)
  allStatusesFiltersStore.clear()

  completeStatusesPaginationStore.resetParams()
  completeStatusesPaginationStore.resetSelectedRow()
  completeStatusesCheckboxStore.resetAll(true)
  completeStatusesFiltersStore.clear()

  reportStatusesPaginationStore.resetParams()
  reportStatusesPaginationStore.resetSelectedRow()
  reportStatusesCheckboxStore.resetAll(true)
  reportStatusesFiltersStore.clear()

  processStatusesPaginationStore.resetParams()
  processStatusesPaginationStore.resetSelectedRow()
  processStatusesCheckboxStore.resetAll(true)
  processStatusesFiltersStore.clear()

  refusedStatusesPaginationStore.resetParams()
  refusedStatusesPaginationStore.resetSelectedRow()
  refusedStatusesCheckboxStore.resetAll(true)
  refusedStatusesFiltersStore.clear()

  pendingStatusesPaginationStore.resetParams()
  pendingStatusesPaginationStore.resetSelectedRow()
  pendingStatusesCheckboxStore.resetAll(true)
  pendingStatusesFiltersStore.clear()
}
